import React from 'react';
import { connect } from 'react-redux';
// import { store, authHeader } from '../../_helpers';
import {Modal, ModalHeader,Button,ModalFooter,Row,ModalBody,Container, Col} from 'reactstrap';
import ServerPaginatedTable from '../utils/pagination.server';
import moment from 'moment';
import PdfIcon from 'react-icons/lib/md/picture-as-pdf'
import ExcelIcon from 'react-icons/lib/md/insert-drive-file';
import ToolTipItem from "../utils/tooltip";
import PageEmptyContent from "../utils/page.empty-content";
import {appConstants, commonConstants} from "../../_constants";
import { appHelpers } from '../../_helpers';
// import SpritePush from "./SpritePush";
import {modalActions} from '../../_actions';
import ReportIcon from 'react-icons/lib/ti/clipboard';
import MatchIcon from 'react-icons/lib/md/insert-link';

const getTSCNaira = () => {
    return "NGN";
};

const SuperAdminDataTable = ({data, matchCallback,converter,downloadFile,toggleModal, totalCount}) =>{
    return (data.Results.length === 0) ?
        (<PageEmptyContent message='No record match your search!'/>) :
        (
            <div className="view">
                <Row>
                    <Col sm='6'>
                        <h5 className="font-weight-normal mb-2">
                            <ReportIcon size="22" color="#43a8df"/>{appHelpers.numberWithCommasOnly(totalCount)} records matched
                        </h5>

                    </Col>
                    <Col sm='6'>
                        <div className="text-right">
                            <strong>Download: </strong>
                            <span className="pointer" onClick={ () => downloadFile(commonConstants.PDF_DOWNLOAD_TYPE)}>
                                            <ToolTipItem key={'downloadPdfIcon'} title={<PdfIcon size="18" color="#e53335" className="icon-picture-as-pdf"/>} content='Download PDF' id={'downloadPdfIcon'}/>
                                        </span>
                            &nbsp;<span className="pointer" onClick={() => downloadFile(commonConstants.EXCEL_DOWNLOAD_TYPE)}>
                                            <ToolTipItem key={'downloadExcelIcon'} title={<ExcelIcon size="18" color="#5ead57" className="icon-insert-drive-file"/>} content='Download Excel' id={'downloadExcelIcon'}/>
                                        </span>
                        </div>
                    </Col>
                </Row>
                {/*Files to be downloaded*/}


                <div className="table-responsive">
                    <table className="table table-striped table-hover">
                        <thead>
                        <tr>

                            <th>
                                <span>Airline</span>
                            </th>
                            <th >
                                <span>Bank</span>
                            </th>
                            <th>
                                <span>Total Amount</span>
                            </th>
                            <th>
                                <span>Currency</span>
                            </th>
                            <th>
                                <span>Number of Flight</span>
                            </th>
                            <th>
                                <span>Invoice Number</span>
                            </th>
                            <th>
                                <span>Date Submitted</span>
                            </th>
                            <th>
                                <span>Invoice Date</span>
                            </th>
                            <th>
                                Payment Date
                            </th>
                            <th>
                                Payment Status
                            </th>
                            <th>Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        {data.Results.map((record, i) =>
                            <tr key={i+1}>
                                <td
                                    className="text-capitalize">{converter(record.AirlineId)}</td>
                                <td>{record.Bank}</td>
                                <td className="text-capitalize">{appHelpers.numberWithCommas(record.Amount)}</td>
                                <td>{getTSCNaira()}</td>
                                <td  className="text-capitalize">{record.ManifestCount}</td>
                                <td>{record.InvoiceNumber}</td>
                                <td>{moment(record.StartDate).format('MMM Do YYYY')}</td>
                                <td>{moment(record.InvoiceDate).format('MMM Do YYYY')}</td>
                                <td>{record.PaymentDate === null ? '' : moment(record.PaymentDate).format('MMM Do YYYY')}</td>
                                <td>{record.Paid === 1 ? 'Paid': 'Unpaid'}</td>
                                <td>
                                    <span className="text-primary pointer" onClick={(e) => matchCallback(record)}>
                                    <ToolTipItem key={i + 'matchPayment'} title={<MatchIcon size="15" color="#43a8df"/>} content='Match Payment' id={i + 'matchPayment'}/>
                                    </span>
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>
            </div>
        )
}

const DataTable = ({data,matchCallback,converter,downloadFile,toggleModal, totalCount}) =>{
    return (data.Results.length === 0) ?
        (<PageEmptyContent message='No record match your search!'/>) :
        (
            <div className="view">
                <Row>
                    <Col sm='6'>
                        <h5 className="font-weight-normal mb-2">
                            <ReportIcon size="22" color="#43a8df"/>{appHelpers.numberWithCommasOnly(totalCount)} records matched
                        </h5>

                    </Col>
                    <Col sm='6'>
                        <div className="text-right">
                            <strong>Download: </strong>
                            <span className="pointer" onClick={ () => downloadFile(commonConstants.PDF_DOWNLOAD_TYPE)}>
                                            <ToolTipItem key={'downloadPdfIcon'} title={<PdfIcon size="18" color="#e53335" className="icon-picture-as-pdf"/>} content='Download PDF' id={'downloadPdfIcon'}/>
                                        </span>
                            &nbsp;<span className="pointer" onClick={() => downloadFile(commonConstants.EXCEL_DOWNLOAD_TYPE)}>
                                            <ToolTipItem key={'downloadExcelIcon'} title={<ExcelIcon size="18" color="#5ead57" className="icon-insert-drive-file"/>} content='Download Excel' id={'downloadExcelIcon'}/>
                                        </span>
                        </div>
                    </Col>
                </Row>
                {/*Files to be downloaded*/}


                <div className="table-responsive">
                    <table className="table table-striped table-hover">
                        <thead>
                        <tr>

                            <th>
                                <span>Airline</span>
                            </th>
                            <th >
                                <span>Bank</span>
                            </th>
                            <th>
                                <span>Total Amount</span>
                            </th>
                            <th>
                                <span>Currency</span>
                            </th>
                            <th>
                                <span>Number of Flight</span>
                            </th>
                            <th>
                                <span>Invoice Number</span>
                            </th>
                            <th>
                                <span>Date Submitted</span>
                            </th>
                            <th>
                                <span>Invoice Date</span>
                            </th>
                            <th>
                                Payment Date
                            </th>
                            <th>
                                Payment Status
                            </th>
                            <th>Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        {data.Results.map((record, i) =>
                            <tr key={i+1}>
                                <td
                                    className="text-capitalize">{converter(record.AirlineId)}</td>
                                <td>{record.Bank}</td>
                                <td className="text-capitalize">{appHelpers.numberWithCommas(record.Amount)}</td>
                                <td>{getTSCNaira()}</td>
                                <td  className="text-capitalize">{record.ManifestCount}</td>
                                <td>{record.InvoiceNumber}</td>
                                <td>{moment(record.StartDate).format('MMM Do YYYY')}</td>
                                <td>{moment(record.InvoiceDate).format('MMM Do YYYY')}</td>
                                <td>{record.PaymentDate === null ? '' : moment(record.PaymentDate).format('MMM Do YYYY')}</td>
                                <td>{record.Paid === 1 ? 'Paid': 'Unpaid'}</td>
                                <td>
                                    <span className="text-primary pointer" onClick={(e) => matchCallback(record.Id)}>
                                    <ToolTipItem key={i + 'matchPayment'} title={<MatchIcon size="15" color="#43a8df"/>} content='Match Payment' id={i + 'matchPayment'}/>
                                    </span>
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>
            </div>
        )
}

class PaginatedResult extends React.Component {
    constructor(){
        super()
        this.state = {
            modal: false,
            openModal: false,
            aggregatorId:'',
            url:`${appConstants.PAS_URL}/api/Configuration/Search`,
            pushToSpriteData:'',
            errorMessage1: "Error Posting transactions",
            errorMessage2: "This aggregate has not been pushed to sprite before. Neft reference does not exist",
           successfulMessage: "Posted successfully"
        }
    }
    toggle = (e, modalClass) => {
        if(this.state.modal){
            this.resetModal();
            this.props.dispatch(modalActions.close({'modalClass': modalClass}));
        }else{
            this.props.dispatch(modalActions.open({'modalClass': modalClass}));
        }
    };

    toggleModal = (id) => {
        let { openModal } = this.state;
        this.setState({openModal: !openModal, aggregatorId : id});
    };


    paramsfn(aggId){
        let {aggregatorId,errorMessage1,errorMessage2,successfulMessage} = this.state;
        let user = appHelpers.getActiveUser()
        let userName = JSON.stringify(user.userName)

              /* Push To Sprite API*/
        let pushTOSpriteUrl = "https://avipay.test.vggdev.com/api/Payment/ResendToSprite?aggregateId="+ aggregatorId +"&email="+ userName;
        appHelpers.postRequest(pushTOSpriteUrl,{},{ "Content-Type": "application/json"})
            .then((res) => {
                res.data === errorMessage1 && alert(errorMessage1);
                res.data === successfulMessage && alert(successfulMessage);
            })
             .catch((error) => {
                 alert(errorMessage2);
            });
        this.toggleModal()

    };

    render() {
        const {converter, matchCallback, pageSize, currentPage, totalCount,navigate, recordResults,downloadFile} = this.props;
        const {aggregatorId} =this.state;
        const userRole = appHelpers.getActiveUser().AviRole;

        // console.log(converter);



        return (
            <div>
                <div className="row">
                    <div className="col-md-12 col-sm-12 mb-4" >
                        {
                            (userRole === appConstants.ROLES.SUPER_ADMIN) &&
                            <ServerPaginatedTable  currentPage={currentPage} fetchMore={navigate} target={<SuperAdminDataTable totalCount={totalCount} toggleModal={this.toggleModal} data={recordResults} downloadFile={downloadFile} matchCallback={matchCallback} converter={converter} />} pageSize={pageSize} totalCount={totalCount }/>
                        }
                        {
                            (userRole !== appConstants.ROLES.SUPER_ADMIN) &&
                                <ServerPaginatedTable  currentPage={currentPage} fetchMore={navigate} target={<DataTable totalCount={totalCount} toggleModal={this.toggleModal} data={recordResults} downloadFile={downloadFile} matchCallback={matchCallback} converter={converter} />} pageSize={pageSize} totalCount={totalCount }/>
                        }
                    </div>
                </div>
                <Modal size={'lg'} isOpen={this.state.openModal} toggle={this.toggleModal} className={this.state.modalClass}>
                    <ModalHeader toggle={this.toggleModal}>Repush To Sprite</ModalHeader>
                    <ModalBody>
                        <Container>
                            <Row>
                                Are you sure you want to repush this payment?
                            </Row>
                        </Container>
                    </ModalBody>
                    <ModalFooter>
                        <Button className="btn-avi-primary"  onClick = {(e)=>this.paramsfn(aggregatorId)}> Proceed </Button>
                        <Button color="secondary" onClick={(e)=>this.toggleModal(aggregatorId)}>Cancel</Button>
                    </ModalFooter>
                    {/*<SpritePush toggleModal={this.toggleModal} paramsfn={this.paramsfn.bind(this)}/>*/}
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        modal: state.modal,
    };
}

export default connect (mapStateToProps)(PaginatedResult)



// WEBPACK FOOTER //
// ./src/views/matchDomesticPayment/matched-records.js